import React from "react";
import { breadcrumbs } from "../../common/breadcrumbs";
import { TopBanner } from "../../common/TopBanner";
import { Link } from "../../lib/Link";

export const voice_case1 = type => {
  document.title = 'トランクルームをお探しなら『ハローストレージ』【公式】｜お客様インタビュー｜仕事道具の収納場所に借りました'; 
  return (
    <div className="container">
      {breadcrumbs(type, [
        { href: "/voice2/", text: "お客様の声" },
        {
          text: " 仕事道具の収納場所に借りました。",
        },
      ])}
      
      <div className="voice_case">
        <h2>活用事例</h2>
        <div className="content">
          <div className="collection">
            <div className="interview_header">
              <div className="title">お客様のご紹介</div>
              <div className="person">
                <span>ユッキー様</span>
                <br />
                <span>自営業　28歳　独身</span>
                <br />
                <span>市川市在住</span>
              </div>
              <div className="profile">
                <span>
                  夏はサーフィン、冬はスノーボードというアウトドア派。
                </span>
                <span>
                  仕事柄、休日は不定期だそうですが、夏の休日には友人たちと海辺でBBQなどを楽しむことも多いそう。
                </span>
              </div>
            </div>
            <Link to="/chiba/ichikawashi/detail/2246/" className="item attention">
              <div className="type star">物件データ</div>
              <div className="title">
                  ハローストレージ市川鬼高パート1
              </div>
              <div className="price">
                3,300 /月〜 38,100 /円/月 (0.8帖〜8帖)
              </div>
              <div className="address">千葉県市川市鬼高4丁目12</div>
              <div className="transportation">徒歩 20 分</div>
              <div className="image inside" />
            </Link>
          </div>
          <div className="h_border" />
          <div className="interview">
            <img src="resource/img/static/voice2/voice_case1/img_1.jpg" />
            <div className="title">仕事道具の収納場所に借りました。</div>
            <div className="question">借りて良かった点は？</div>
            <div className="answer">
              <span>
                職業柄、車での移動が多いので、コンテナがインターチェンジ近くにあり、行き帰りでモノの出し入れが出来るのが便利だと思いました。
              </span>
              <br />
              <span>
                最初は工具や部材を置くのが目的でしたが、思ったよりコンテナが広いので家で1年以上放置しているモノや場所をとるものは詰め込んじゃってます。
              </span>
              <br />
              <span>お陰で少しは家が広くなりました。</span>
              <br />
              <span>
                片付いたっていうより、不要なものが減ったって感じですかね。
              </span>
              <br />
              <span>
                広いトコに引っ越したりする面倒を考えると金銭面でもお得感があると思います。
              </span>
            </div>
          </div>
          <div className="interview">
            <img src="resource/img/static/voice2/voice_case1/img_2.jpg" />
            <div className="title">趣味の道具の収納場所にも。</div>
            <div className="question">
              仕事の道具以外にはどんなものを入れていますか？
            </div>
            <div className="answer">
              <span>本当、いろいろです（笑）</span>
              <br />
              <span>
                最初はすぐに使わないようなものが多かったのですが、去年、新しいボードを買ってからはそういう趣味のものも入れています。季節が過ぎれば本当にただの邪魔なものですからね。
              </span>
              <br />
              <span>
                ラックと突っ張り棒で工夫して収納を始めてからは、だんだんコレクター魂が騒いできて、いつか趣味のもの専用のコンテナも借りられたらいいだろうなーと思います。
              </span>
              <br />
              <span>今は手放していますが、バイクなんかも収納したり。</span>
              <br />
              <span>Ｑ：これから借りる方にアドバイスはありますか？</span>
              <br />
              <span>
                よく荷物を出したりするなら、自宅から現場に行く途中とか、家の側とか、とにかく行きやすいところがおすすめです。
              </span>
              <br />
              <span>
                自分も最初は価格を比較して、もう少し安いところも検討したのですが、やっぱり自分にとってのアクセスのよさを重視してよかったと思っています。自宅の目の前にコンテナができないかと思うくらいです！
              </span>
            </div>
          </div>
          <div className="interview_footer">
            <div className="message">
              <span>ユッキー様、</span>
              <span>ご協力ありがとうございました。</span>
              <span>※本文章は弊社社員のお客様インタビューを</span>
              <span>再構成し、掲載しております。</span>
            </div>
          </div>
          <Link to="/voice2/voice_case2/" className="btn black">
            その他の活用事例を見る
          </Link>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./pages/new/voice_case1.jsx